"use strict";

const path = require("path");

module.exports = {
  dev: {
    env: require("./dev.env"),
    // Paths
    assetsSubDirectory: "static",
    assetsPublicPath: "/",
    proxyTable: {
      "/api": {
        // target : 'http://192.168.8.68:9000',
        // target : 'http://192.168.1.165:9000',
        // target: "http://192.168.1.129:9001",
        // target : 'http://358576p24u.zicp.vip:50344',
        target: "http://detect.scentralit.com:9000",
        // target : 'http://127.0.0.1:9000',
        // target : 'http://110.189.152.34:60000',
        changeOrigin: true,
        pathRewrite: {
          "^/api": "",
        },
      },
    },

    host: "0.0.0.0",
    port: 8080,
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false,
    devtool: "cheap-module-eval-source-map",
    cacheBusting: true,
    cssSourceMap: true,
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, "../dist/index.html"),

    // Paths
    assetsRoot: path.resolve(__dirname, "../dist"),
    assetsSubDirectory: "static",
    assetsPublicPath: "/",

    productionSourceMap: true,
    devtool: "#source-map",

    productionGzip: false,
    productionGzipExtensions: ["js", "css"],

    bundleAnalyzerReport: process.env.npm_config_report,
  },

  configureWebpack: {
    externals: {
      AMap: "AMap", // 高德地图配置
    },
  },
};



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 1